webpackJsonp([130921777227129],{

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Anatomy = __webpack_require__(10);
	
	var _Anatomy2 = _interopRequireDefault(_Anatomy);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Anatomy2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      '/src/decorators/UserIsAuthorized.js'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This file provides a higher order component that you can use to block the rendering of a component that user does not have permission to interact with.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When this component is rendered, the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'isAuthenticated()'
	      ),
	      ' method will be invoked.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If it returns ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'true'
	      ),
	      ', the component this wraps will be rendered, and the application will appear as if this decorator doesn\'t exist.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If it returns ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'false'
	      ),
	      ', nothing will be rendered, and the application will appear as if that component doesn\'t exist.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import { AuthorizationGenerator } from \'lore-auth\';\n\n      export default AuthorizationGenerator({\n        displayName: \'UserIsAuthorized\',\n\n        isAuthorized() {\n          return true;\n        }\n      })\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-anatomy-src-decorators-user-is-authorized-js-8749c2773511e13f658f.js